<h3 mat-dialog-title>Open View</h3>
<mat-dialog-content>
  <mat-action-list>
    @for (preset of available; track preset) {
    <mat-list-item (click)="selectView(preset.id, preset.entityName)">
      <mat-icon fontIcon="fa-file-spreadsheet" fontSet="fat" class="view-icon"></mat-icon>
      {{ preset.searchName }}
    </mat-list-item>
    }
  </mat-action-list>
</mat-dialog-content>